import 'reflect-metadata';
import { BaseEntity } from '../entities/base.entity';
import { RelationRef } from '../types/entity-types';

export function Relation() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (target: any, propertyKey: string) {
    Reflect.defineMetadata('isRelation', true, target, propertyKey);
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isRelation(target: any, propertyKey: string): boolean {
  const val = target[propertyKey];

  if (Reflect.getMetadata('isRelation', target, propertyKey)) {
    return true;
  }

  if (val && typeof val === 'object' && 'id' in val && 'type' in val) {
    return true;
  }

  return Array.isArray(val) && val.length > 0 && val.every(v => v && typeof v === 'object' && 'id' in v && 'type' in v);
}

/**
 * Normalize a single relation for a form control.
 * Works for a RelationRef object or an array of RelationRefs.
 * Returns the ID string or null if not set.
 */
export function normalizeOneRelation<T extends BaseEntity>(
  relation?: RelationRef<T> | RelationRef<T>[]
): string | null {
  if (!relation) return null;
  if (Array.isArray(relation)) return relation[0]?.id ?? null;
  return relation.id;
}

export function normalizeManyRelations<T extends BaseEntity>(
  relations?: RelationRef<T>[]
): string[] {
  if (!relations) return [];
  return relations.map(r => r.id);
}

export function normalizeEntitiesToRelations<T extends BaseEntity>(
  entities: T[],
  type: string
): RelationRef<T>[] {
  if (!entities) return [];
  return entities.map(e => ({
    id: e.id,
    type
  }));
}

export function normalizeEntityToRelation(
  entity: BaseEntity | null | undefined,
  type: string
): { id: string, type: string } | undefined {
  if (!entity) return undefined;
  return {
    id: entity.id,
    type,
  };
}
